<div
  *ngIf="payment$ | async as payment"
  class="p-8"
  style="-webkit-print-color-adjust: exact; print-color-adjust: exact"
>
  <div>
    <ws-payment-invoice [static]="true" [payment]="payment"></ws-payment-invoice>
  </div>
</div>
